/* =========================================================================
   MapleWeld — collection page behaviour.

   The filter rail is a plain GET <form>. That is deliberate: every filtered
   view is a real URL, so it can be bookmarked, shared, linked from an email,
   and crawled — none of which survives an AJAX-only filter. This script only
   removes the friction on top of that form:

     1. desktop: ticking a box submits immediately, so the Apply button is
        redundant and gets hidden. No JS, and the button is still there.
     2. mobile: the rail is a slide-over. Submitting on every tick would slam
        the page under the drawer, so there the Apply button stays and does
        the work.
     3. sort submits on change.

   Everything is wrapped so a failure leaves a working, if manual, form.
   ========================================================================= */
(function () {
  'use strict';

  var DESKTOP = 1000; // matches the CSS breakpoint where the rail stops being a drawer

  function isDesktop() {
    return window.innerWidth > DESKTOP;
  }

  function init() {
    var form   = document.querySelector('[data-mwk-form]');
    var aside  = document.querySelector('[data-mwk-aside]');
    var scrim  = document.querySelector('[data-mwk-scrim]');
    var openB  = document.querySelector('[data-mwk-open]');
    var closeB = document.querySelector('[data-mwk-close]');
    var sort   = document.querySelector('[data-mwk-sort]');

    /* ---- sort ---- */
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    if (!form) return;

    /* ---- THE STACKING TRAP — read this before touching the drawer ----

       On a phone the filter rail is position:fixed with z-index:999, and the
       scrim behind it is z-index:998. Those two numbers look right and are
       not, because .mwk__aside lives inside .mwk__wrap, which is
       position:relative + z-index:2. That combination opens a NEW STACKING
       CONTEXT, so the drawer's 999 is only 999 *inside that wrapper* — against
       the rest of the page the whole wrapper ranks as 2.

       The scrim is a child of .mwk with no such ancestor, so its 998 is real,
       and the sticky site header's 900 is real too. The result on a phone:
       tapping Filter slid the rail in UNDERNEATH its own scrim and underneath
       the header. The panel looked greyed out, the header bled through it, and
       every tap landed on the scrim instead of the control beneath — which is
       exactly the "I cannot click anything" report.

       The wrapper's z-index:2 is doing real work for the rest of the page, so
       it is not removed: it is neutralised only while the drawer is open, and
       restored on close. position:relative WITHOUT a numeric z-index does not
       open a stacking context, so the drawer's own z-index becomes global for
       exactly as long as it needs to be. Set inline so it always wins, and so
       this fix travels with the behaviour it belongs to rather than sitting in
       a stylesheet far away from the open/close code.
       ------------------------------------------------------------------- */
    var wrap = aside && aside.closest ? aside.closest('.mwk__wrap') : null;
    var wrapZ = null;

    function liftDrawer() {
      if (wrap) { wrapZ = wrap.style.zIndex; wrap.style.zIndex = 'auto'; }
      if (aside) aside.style.zIndex = '1000';   // above the scrim (998) and the header (900)
    }
    function dropDrawer() {
      if (wrap) { wrap.style.zIndex = wrapZ === null ? '' : wrapZ; wrapZ = null; }
      if (aside) aside.style.zIndex = '';
    }

    /* ---- drawer ---- */
    function openDrawer() {
      if (!aside) return;
      liftDrawer();
      aside.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      /* Both elements: <body> alone leaves the page scrollable behind the
         drawer on iOS Safari, which drags the grid around under the finger. */
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      if (closeB) closeB.focus();
    }
    function closeDrawer() {
      if (!aside) return;
      aside.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (openB) openB.focus();
      /* Only after the slide-out has finished, or the rail pops behind the
         scrim for the length of the transition on its way out. */
      setTimeout(dropDrawer, 320);
    }
    if (openB) openB.addEventListener('click', openDrawer);
    if (closeB) closeB.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aside && aside.classList.contains('is-open')) closeDrawer();
    });

    /* Rotating to landscape past the breakpoint turns the drawer back into a
       static rail; the promoted z-index would then outrank the header for no
       reason. Reset whenever we are on the desktop layout and not open. */
    window.addEventListener('resize', function () {
      if (isDesktop() && aside && !aside.classList.contains('is-open')) dropDrawer();
    }, { passive: true });

    /* ---- submit on change, desktop only ----
       page= is dropped on every submit: staying on page 4 after narrowing the
       results to nine products lands the customer on an empty grid, which
       reads as "no stock" rather than "wrong page".                        */
    function submit() {
      var page = form.querySelector('input[name="page"]');
      if (page) page.parentNode.removeChild(page);
      form.submit();
    }

    function applyMode() {
      if (isDesktop()) form.classList.remove('mwk__form--manual');
      else form.classList.add('mwk__form--manual');
    }
    applyMode();
    window.addEventListener('resize', applyMode, { passive: true });

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (!isDesktop()) return;                       // mobile waits for Apply
      if (t.type === 'checkbox' || t.type === 'radio') submit();
    });

    // price fields: only on commit, never per keystroke
    var priceInputs = form.querySelectorAll('[data-mwk-price]');
    for (var i = 0; i < priceInputs.length; i++) {
      priceInputs[i].addEventListener('change', function () {
        if (isDesktop()) submit();
      });
      priceInputs[i].addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });
    }
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {}
}());
